export const breadCrumbItems = [
  {
    text: "Gateway Dashboard",
    key: "gateway-dashboard",
  },
];

export const STATUS_TO_PILL = { OK: 'green', WARNING: 'amber', CRITICAL: 'red', NO_DATA: 'gray' };
export const STATUS_TO_LABEL = { OK: 'Ok', WARNING: 'Warning', CRITICAL: 'Critical', NO_DATA: 'No data' };
export const PILL_BG = { OK: '#34d399', WARNING: '#fbbf24', CRITICAL: '#dc2626', NO_DATA: '#585858' };
export const PILL_TEXT = { OK: '#ffffff', WARNING: '#7a4a00', CRITICAL: '#ffffff', NO_DATA: '#ffffff' };
export const CATEGORY_LEVEL_LABEL = { OK: 'Ok', WARNING: 'Warn', CRITICAL: 'Crit', NO_DATA: 'No data' };
export const HEARTBEAT_PAGE_SIZE = 10;

export const intervalDropdownStyles = {
  root: { width: 140, minWidth: 140 },
  dropdown: { width: 140 },
  title: {
    borderRadius: "6px",
    height: "22px",
    lineHeight: "22px",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
  },
  caretDownWrapper: { height: "22px", lineHeight: "22px" },
  caretDown: { fontSize: "10px" },
};


export const actionButtonStyle = {
  root: {
    padding: "0px 8px",
    height: "22px",
    minHeight: "22px",
    minWidth: "92px",
    maxWidth: "100%",
    borderRadius: "5px",
  },
  label: {
    fontSize: "11px",
    fontWeight: "400",
    lineHeight: "20px",
  },
};

export const pagerButtonStyle = {
  root: {
    padding: "0px 8px",
    height: "20px",
    minHeight: "20px",
    minWidth: "48px",
    borderRadius: "5px",
  },
  label: {
    fontSize: "11px",
    fontWeight: "400",
    lineHeight: "20px",
  },
};

export function heartbeatPillClass(percent) {
  if (percent >= 100) return 'green';
  if (percent >= 25) return 'amber';
  return 'red';
}

export function formatDateTime(iso) {
  if (!iso) return '\u2014';
  const d = new Date(iso);
  return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function formatTime(iso) {
  if (!iso) return '\u2014';
  const d = new Date(iso);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}
